import styled, { css } from 'styled-components';

export const TextWithEllipsis = styled.span<{ maxWidth?: number }>`
    width: 100%;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    ${props => props.maxWidth && css`
        max-width: ${props.maxWidth}px;
    `}
`;
